var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pb-16",attrs:{"fill-height":""}},[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('span',{staticClass:"display-1"},[_vm._v("Unauthorized. Reach out to Diana Previtire for access.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }